import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpxbqc3arv: FaireProductEntity = {
  token: "p_cpxbqc3arv",
  type: "product",
  name: "Gift Set - Lotion & Lip Balm Duo, Lemongrass Lavender",
  brandToken: "b_3938a733",
  brandName: "DANI Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/3dfe25342883c89d044541db7de53392de18df7b1ce20170e99b38b56ea02370.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4bb37034df074b08d90f09effed1fc633ca48cfab53e2faafe009de65bb8cbc4.jpeg",
    "https://cdn.faire.com/fastly/30ff0cb4e2d7add662948c9308ddf78917c7d3a51f5707b652cb5561bddd60c3.jpeg",
    "https://cdn.faire.com/fastly/d12da44d18ef35892e4bd41a68ff162cfe0d604f09a2e8ea0b9d1f5d23936d76.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "DANI Naturals Lotion & Lip Balm Duo is the perfect travel and on-the-go set which includes a 1 2oz lotion and 1 lip balm in the same scent all in a cute gift-able box.\n\nDANI Naturals Lotion provides natural hydration for all skin types and is gluten-free.  Enriched with shea butter, borage seed oil, aloe vera & green tea extract blended into a botanical base to make our lotion thick and moisturizing - never greasy!\n\nDANI Naturals Lip Balm is formulated to nourish and protect dry lips - perfect for everyday use. Made with natural and organic ingredients, our lip balm soothes and moisturizes plus is gluten-free!\n\nThe Scent:  DANI's Lemongrass Lavender is a combination of pure lavender and added lemongrass, geranium, and a hint of rosemary to create the ultimate yin-yang experience - both calming and uplifting!  This is what CALM smells like.\n\nPerfect Christmas gift, stocking stuffers, and complements most holiday decorations!",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:35.117Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
